import { colors, fonts } from 'theme'
import css from 'styled-jsx/css'

export default css`
  .latest-properties {
    padding-top: 100px;
    padding-bottom: 3rem;
    width: 100%;
    text-align: center;
    background-color: ${colors.lightGray};
  }

  .latest-properties-title {
    font: ${fonts.bold};
    font-size: 2.25rem;
    color: ${colors.secondary};
    line-height: 3rem;
    margin-bottom: 38px;
  }
`